// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { ExternalExamType } from "../../types";
import { getExternalExams } from "../../api";

export const useVFExternalExams = (
  clinicId: string | undefined,
  patientId: string | undefined,
  enabled: boolean = false
) => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<ExternalExamType>>({
    queryKey: ["vf-external-exams", clinicId, patientId],
    queryFn: async () => {
      if (!clinicId || !patientId) throw new Error();
      const token = await getToken();
      return getExternalExams(token, clinicId, patientId, "visualfield");
    },
    enabled: Boolean(clinicId && patientId && enabled),
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });
};
